import { ReactElement } from 'react';
import { render } from '@testing-library/react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { APIProvider } from '@vis.gl/react-google-maps';
import { store } from '@carcareers/store';
import { SnackbarProvider, LoadingProvider } from '@carcareers/contexts';
import { theme } from '@carcareers/theme';

export const renderWithProviders = (ui: ReactElement) => {
  return render(
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <APIProvider
            apiKey="test-api-key"
            libraries={['places', 'visualization']}
          >
            <BrowserRouter>
              <SnackbarProvider>
                <LoadingProvider>
                  {ui}
                </LoadingProvider>
              </SnackbarProvider>
            </BrowserRouter>
          </APIProvider>
        </LocalizationProvider>
      </ThemeProvider>
    </Provider>
  );
};

export const renderWithProvidersNoMaps = (ui: ReactElement) => {
  return render(
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <BrowserRouter>
            <SnackbarProvider>
              <LoadingProvider>
                {ui}
              </LoadingProvider>
            </SnackbarProvider>
          </BrowserRouter>
        </LocalizationProvider>
      </ThemeProvider>
    </Provider>
  );
};

export const renderWith = (ui: ReactElement, type: 'with-maps' | 'no-maps' | undefined) => {
  if (type === 'with-maps' || type === undefined) {
    return renderWithProviders(ui);
  }
  return renderWithProvidersNoMaps(ui);
};


export * from '@testing-library/react';
export { renderWithProviders as render };
